export const EsignDocumentForm = {
  FORM_573471: 573471, // ISP-1200 Application for a CPP Death Benefit
  FORM_859822: 859822, // ISP-1201 Notification of Death Form for CPP and Old Age Security
  FORM_287403: 287403, // ISP-1300 CPP Survivor's Pension and Children's Benefits
  FORM_701554: 701554, // ISP-3104 Statutory Declaration of Common-law Union
  FORM_918855: 918855, // CRA to Update Records
  FORM_625776: 625776, // Equifax notice
  FORM_384607: 384607, // Notice to TransUnion
  FORM_209413: 209413, // tax authorization form
  FORM_551851: 551851, // Directions and Authorization
  FORM_967195: 967195, // Notice to Franchise Tax Board
  FORM_478088: 478088, // Notice to Department of Health Care Services
  FORM_381593: 381593, // Notice to Victims Compensation Board
  FORM_401697: 401697, // DE-157 Notice to Creditors
  FORM_302708: 302708, // Notice of Death to Experian,
  FORM_569844: 569844, // F56 Notice Concerning Fiduciary Responsibility
  FORM_788121: 788121, // DE-160 Inventory and appraisal
  FORM_463640: 463640, // DE-161 attachment #1
  FORM_871042: 871042, // DE-161 attachment #2
  FORM_902309: 902309, // DE-161 attachment 1 v2
  FORM_337290: 337290, // DE-161 attachment 2 v2
  FORM_147987: 147987 // MC-025
};
